/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TutorialTeamHealth_flags = {
    readonly flags: ReadonlyArray<string | null> | null;
    readonly " $refType": "TutorialTeamHealth_flags";
};
export type TutorialTeamHealth_flags$data = TutorialTeamHealth_flags;
export type TutorialTeamHealth_flags$key = {
    readonly " $data"?: TutorialTeamHealth_flags$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"TutorialTeamHealth_flags">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "TutorialTeamHealth_flags",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "flags",
            "storageKey": null
        }
    ],
    "type": "Flags",
    "abstractKey": null
} as any;
(node as any).hash = '22efe84c32cdd0039a50a06650c357b7';
export default node;
